module.exports = __webpack_public_path__ + "static/img/2.e5ee8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/yhw/2.jpg
// module id = EU1c
// module chunks = 1